import { render, staticRenderFns } from "./OsterleyPark.vue?vue&type=template&id=2e8ed31d&"
import script from "./OsterleyPark.vue?vue&type=script&lang=js&"
export * from "./OsterleyPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports